import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles/theme.css";

export const contentRow = style({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "baseline",
  justifyContent: "space-between",
  rowGap: vars.space["2xs"],
  columnGap: vars.space.s,
  width: "100%",
});

export const newsText = style({
  flex: "1 1 auto",
  minWidth: 0,
});

export const newsLink = style({
  flex: "0 0 auto",
});
